import React, { useEffect, useState } from "react";
import axios from "axios";
import CopyServices from "./CopyServices";
import ServicesTableCont from "./ServicesTableCont";
import LoadingDots from "../UI/LoadingDots";
import { DDD } from "../../lib/ddd/ddd";

const apiRequestAddress = process.env.REACT_APP_API_ENDPOINT || window.location.origin + "/json.rpc";
const ddd = new DDD(apiRequestAddress);

const ServicesContainer = () => {
  const [data, setData] = useState(null);
  const [dataType, setDataType] = useState(null);
  const [isLoading, setIsLoading] = useState(null);
  const [error, setError] = useState(null);

  const getData = (exitEditMode) => {
    console.log("getdata");
    setIsLoading(true);
    axios
      .post(
        apiRequestAddress,
        {
          jsonrpc: "2.0",
          method: "Data.GetEntityData",
          params: {
            entity: "EU_AOrg_ServicesEndpoints",
            format: "Full",
          },
          id: 265,
        },
        {
          withCredentials: true,
        }
      )
      .then((res) => {
        setData(res.data.result.data);
        console.log("changed data");

        axios
          .post(
            apiRequestAddress,
            {
              jsonrpc: "2.0",
              method: "Data.GetEntityInfo",
              params: {
                entity: "EU_AOrg_ServicesEndpoints",
                format: "Full",
              },
              id: 265,
            },
            {
              withCredentials: true,
            }
          )
          .then((secRes) => {
            if (typeof exitEditMode === "function") {
              console.log("executing");
              exitEditMode();
            }
            setDataType(secRes.data.result.tables[0]["_fields"]);
            console.log(secRes.data.result.tables[0]["_fields"]);
            setIsLoading(false);
          });
      });
  };

  const onCopyServices = () => {
    axios
      .post(
        apiRequestAddress,
        {
          jsonrpc: "2.0",
          method: "Extension.Execute",
          params: {
            extension: "EUeInvoices.RewriteServiceOnOrg",
          },
          id: 266,
        },
        {
          withCredentials: true,
        }
      )
      .then((res) => {
        if (res.data.result && res.data.result.Status.toUpperCase() === "OK") {
          getData();
        } else {
          if (res.data.result.Reason) setError(res.data.result.Reason);
        }
      });
  };

  useEffect(() => {
    getData();
  }, []);

  return (
    <>
      {!isLoading &&
        data &&
        (data.length === 0 ? (
          <CopyServices onCopyServices={onCopyServices} error={error} />
        ) : (
          <ServicesTableCont
            data={data}
            dataType={dataType}
            getData={getData}
            onCopyServices={onCopyServices}
          />
        ))}
      {isLoading && <LoadingDots />}
    </>
  );
};

export default ServicesContainer;
